module.exports = __webpack_public_path__ + "2c73a766f6fc03cf2209e7675f6d4595.MP3";